// extracted by mini-css-extract-plugin
export default {"container":"LoanApplicationDashboard_container__mcUxT"};